module.exports = __webpack_public_path__ + "img/people-leader.794ced40.svg";